import React from 'react';
import { Redirect } from 'react-router-dom';
import { useRouter } from '../../../../hooks/router';

interface Props {
    pageOrPath: any;
    params?: any;
}

export function XRouterRedirect({ pageOrPath, params }: Props) {
    const { replaceParams } = useRouter();
    return <Redirect to={replaceParams(pageOrPath?.route || pageOrPath, params)} />;
}
